export class Navigation {
	constructor() {
		this.open = false
		this.toggle = document.querySelectorAll('[data-toggle-nav]')

		this.toggle.forEach((button) => {
			button.addEventListener('click', () => {
				this.open ? this.closeNavigation() : this.openNavigation()
			})
		})

		window.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				this.closeNavigation()
			}
		})
	}
	openNavigation() {
		this.open = true
		document.documentElement.classList.add('nav-open')
		document.documentElement.setAttribute('data-nav-status', 'open')
	}
	closeNavigation() {
		this.open = false
		document.documentElement.classList.remove('nav-open')
		document.documentElement.setAttribute('data-nav-status', 'closed')
	}
	snapCloseNavigation() {}
}